import GoodsApi from "@/Api/GoodsApi";
import { utcEndSecond, utcStartSecond } from "@/Common/date";
import { TableActions } from "@/Common/Table/TableActions";
import { WarehouseType } from "@/Models/Enums/WarehouseType";
import { ExcludeBasePagination, StockSlotSplitPageProps } from "@/Models/Other/BaseSplitPageProps";
import { SelectItem } from "@/Models/Other/SelectItem";
import { Button, DatePicker, Form, Input, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { getSelectItems2 as getWarehouseSelectItems } from "@/Api/WarehouseController";
export function SearchComponent({ onSearch }: { onSearch: (data: ExcludeBasePagination<StockSlotSplitPageProps>) => void; }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<SelectItem[]>([]);
    const [form] = useForm();
    const [warehouseOptions, setWarehouseOptions] = useState<SelectItem[]>([]);
    useEffect(() => {
        setLoading(true);
        getWarehouseSelectItems(
            [WarehouseType.Stereoscopic, WarehouseType.Flat],
            ''
        ) //daiv
            .then(setWarehouseOptions)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);
    return <TableActions>
        <Form form={form} layout="inline" onFinish={s => {
            let start: number | undefined = undefined;
            let end: number | undefined = undefined;
            if (s["dateRange"]) {
                start = utcStartSecond(s["dateRange"][0]);
                end = utcEndSecond(s["dateRange"][1]);
            }
            onSearch(
                {
                    start, end,
                    billCode: s["billCode"],
                    slotCode: s["slotCode"],
                    stockCode: s["stockCode"],
                    goodsId: s["goodsId"],
                    warehouseIds: s["warehouseIds"], lanewayName: s["lanewayName"]
                }
            );
        }}>
            <Form.Item name="warehouseIds" label="库房">
                <Select
                    allowClear
                    style={{ minWidth: 100 }}
                    loading={loading}
                    options={warehouseOptions}
                    optionFilterProp="label"
                    showSearch
                    mode="multiple"
                />
            </Form.Item>
            <Form.Item label="巷道名称" name="lanewayName">
                <Input style={{ width: 100 }} />
            </Form.Item>
            <Form.Item name="dateRange" label="日期范围">
                <DatePicker.RangePicker style={{ width: 200 }} showTime={{ format: 'HH:mm:ss' }} format="YYYY-MM-DD HH:mm:ss"></DatePicker.RangePicker>
            </Form.Item>
            <Form.Item label="入库单号" name="billCode">
                <Input />
            </Form.Item>
            <Form.Item label="托盘条码" name="stockCode">
                <Input style={{ width: 100 }} />
            </Form.Item>
            <Form.Item label="储位编码" name="slotCode">
                <Input style={{ width: 100 }} />
            </Form.Item>
            <Form.Item label="物品信息" name="goodsId">
                <Select onDropdownVisibleChange={data.length === 0 ? s => {
                    if (s) {
                        setLoading(true);
                        GoodsApi.getSelectItems().then(a => setData((list) => {
                            return a.map(s => ({
                                label: (<div>
                                    <div>{s.label}</div>
                                    <div>{s.standard}</div>
                                </div>), value: s.value, data: s
                            })) as any
                        })).catch(console.error).finally(() => setLoading(false));
                    }
                } : undefined} filterOption={(input, opt: any) => {
                    return opt.data.label?.toLowerCase().includes(input.toLowerCase())
                        || opt.data.standard?.toLowerCase().includes(input.toLowerCase());
                }} style={{ minWidth: 180 }} loading={loading} options={data} showSearch allowClear />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit">查询</Button>
            </Form.Item>
        </Form>
    </TableActions>;
}
